import { CourseUrl, ExamId, SemesterId, TaskId } from '/imports/domain';
import { end, formatRoute, lit, type, url } from '/imports/modules/Routing';
import { messagesSectionQuery } from '/imports/ui/pages/myCourses/messages/navigation';

export interface PathParams {
  semester: SemesterId;
  courseUrl: CourseUrl;
  examId: ExamId;
}

export const myexamsSlug = 'myexams';

const myexams = lit(myexamsSlug);
const semester = type('semester', SemesterId);
const courseUrl = type('courseUrl', CourseUrl);
const examId = type('examId', ExamId);
const taskId = type('taskId', TaskId);

const base = url(myexams, semester, courseUrl, examId);

export const pageKeys = {
  examEdit: null,
  examPreparation: null,
  examStatus: null,
  userCheck: null,
  overview: null,
  progress: null,
  submissions: null,
  messages: null,
  regrade: null,
  examReview: null,
};

export type Page = keyof typeof pageKeys;
const page = (p: Page) => url(base, lit(p));

export const myExamsRoute = url(myexams, end);
export const createRoute = url(myexams, lit('create'), end);

export const examRoute = url(base, end);
export const manageRoute = url(page('examStatus'), end);
export const messagesRoute = url(page('messages'), messagesSectionQuery, end);
export const editRoute = url(page('examEdit'), end);
export const userCheckRoute = url(page('userCheck'), end);
export const overviewRoute = url(page('overview'), end);
export const preparationRoute = url(page('examPreparation'), end);
export const submissionsRoute = url(page('submissions'), end);
export const progressRoute = url(page('progress'), end);
export const regradeRoute = url(page('regrade'), end);
export const regradeTaskRoute = url(page('regrade'), taskId, end);
export const reviewRoute = url(page('examReview'), end);

export const regradeTaskLink = formatRoute(regradeTaskRoute);
